<template>
    <span v-if="battery == null || battery == 'undefined'">
        _
    </span>
    <span v-else-if="!Number.isInteger(battery)">
        {{ battery }}
    </span>
    <span v-else-if="battery >= 50" class="ui-badge status-badge--ok">
        <font-awesome-icon :icon="['fas', 'battery-full']" rotation=270 class="me-1" /> {{ battery }}%</span>
    <span v-else-if="battery >= 30" class="ui-badge alert-badge--warning">
        <font-awesome-icon :icon="['fas', 'battery-half']" rotation=270 class="me-1" /> {{ battery }}%</span>
    <span v-else class="ui-badge alert-badge--danger">
        <font-awesome-icon :icon="['fas', 'battery-quarter']" rotation=270 class="me-1" /> {{ battery }}%</span>
</template>

<script>
export default {
    props: ['battery']
}
</script>